import React from "react";
import Link from "next/link";
import Text from "@src/lib/ui/Text";
import TriangleWarningOutlineIcon from "@src/lib/icons/18px/triangle-warning-outline";
import useUser from "@src/features/app/hooks/useUser";

export const AddPhoneNumberBanner: React.FC = () => {
  const { user } = useUser();
  if (user?.phoneNumber) return null;
  return (
    <div className="mt-3 flex shrink-0">
      <Link
        href={{
          pathname: "/users/[id]",
          query: { id: (user?.id || "").toString() },
        }}
        className="flex flex-1 items-center justify-center gap-2 self-stretch bg-purple-2 p-3"
      >
        <TriangleWarningOutlineIcon className="text-purple-12" />
        <Text variant="compact-title" className="text-purple-12">
          <span className="underline">Add a phone number</span> to your account
          to sign into the mobile app
        </Text>
      </Link>
    </div>
  );
};
